/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import ManifestList from "./ManifestList";
import {
  Row,
  Col,
  Button,
  Spin,
  Input,
  message,
  Popconfirm,
  Form,
  Select,
  Radio,
} from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { json, useNavigate } from "react-router-dom";

import {
  getPacketListBySatus,
  patchPacketShipment,
  patchManifestScan,
  patchPacketShipmentClear,
} from "../../../actionsMethods/manifestMethods";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import API from "../../../api";
import urls from "../../../api/urls";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { capitaliseWithHyphen } from "../../../utils";
import show from "../../../assests/images/show.png";
import moment from "moment";
import Heading from "../../../components/Heading";
import useCustomNavigate from "../../../components/customNavigationHook";
const {
  ELIGIBLE_MANIFEST_LIST,
  CP_EWAY_BILL_TABLE,
  PATCH_SHIPMENTS_TO_LOAD,
  CREATE_MANIFEST_NEW,
  ELIGIBLE_WEEK_MANIFEST_LIST,
  GET_CLIENT_LIST_NEW,
  GET_CLIENT_INNO,
} = urls;

function ScanedandManifestList() {
  const currentEnv = process.env.REACT_APP_ENV;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState(true);
  const [clientId, setClientId] = useState(null);
  const [pastPendingCount, setPastPendingCount] = useState(0);
  const [todayCount, setTodayCount] = useState(0);
  const [hubList, setHubList] = useState([]);
  const scannedLimit = 2000;

  let barcode = "";
  let interval;
  const [manifestListArr, setManifestListArr] = useState([]);
  const [scannedManifestListArr, setScannedManifestListArr] = useState([]);
  const [hubId, setHubId] = useState(null);
  const [filters, setFilters] = useState({});

  // const [manifestScannedArr, setManifestScannedArr] = useState([]);
  const debounceTimeout = useRef(null);

  const localScannedAwbs =
    JSON.parse(localStorage.getItem("scannedAwbs")) || [];

  const { fetching: loader1, result: packetAndShipment } = useSelector(
    (state) => state.manifestReducer.getPacketListBySatusReducer,
    shallowEqual
  );

  const {
    fetching: loader3,
    result: patchPacketShipmentResult,
    error: patchPacketShipmentError,
  } = useSelector(
    (state) => state.manifestReducer.patchPacketShipmentReducer,
    shallowEqual
  );

  const { fetching: loader2, error: manifestedError } = useSelector(
    (state) => state.manifestReducer.patchManifestScanReducer,
    shallowEqual
  );

  useEffect(() => {
    if (patchPacketShipmentResult) {
      localStorage.removeItem("scannedAwbs");
      navigate(`/truck/${patchPacketShipmentResult?.manifestId}`);
    }

    if (patchPacketShipmentError) {
      message.error(patchPacketShipmentError?.message);
    }

    return () => {
      dispatch(patchPacketShipmentClear());
    };
  }, [patchPacketShipmentError, patchPacketShipmentResult]);

  useEffect(() => {
    if (manifestedError !== null) {
      message.error(manifestedError?.message);
    }
  }, [manifestedError]);

  useEffect(() => {
    getHubList();
  }, []);

  const getHubList = async () => {
    let data_ = JSON.parse(localStorage.getItem("userId"));
    let state = data_?.premises?.state;
    let baseUrl =
      currentEnv == "qa"
        ? "https://apigw.qa.innofulfill.com"
        : "https://apigw.prod.innofulfill.com";
    let url = "/hubops-details";
    let response = await API.Api(
      baseUrl + url + "?search_state=" + state
    ).getCustomHeader({
      "x-api-key": "EIUn6NahhO6PA4V7t8R9B5A4APMzmsBh5IEqTZ4g",
    });
    if (response?.status) {
      let data = response?.response?.data?.data;
      setHubList(
        data?.map((item) => ({
          label: item?.premiseName,
          value: item?.premiseId,
          hubName: item?.premiseName,
          hubAddress:
            item?.addressLine1 + " " + item?.addressLine2 !== null
              ? item?.addressLine1
              : "",
        })) || []
      );
    }
  };

  // useEffect(() => {
  //   setManifestFor(localStorage.getItem("manifestFor"));
  // }, [manifestFor]);

  useEffect(() => {
    //dispatch(getPacketListBySatus("manifest", "both"));
  }, [loader2]);

  useEffect(() => {
    if (!loader1 && !loader2 && packetAndShipment) {
      const packet = packetAndShipment?.packetsdto || [];
      const shipment = packetAndShipment?.shipmentDto || [];
      const arr = [...packet, ...shipment];
      let getData = JSON.parse(localStorage.getItem("scannedAwbs"));
      let processedData = arr?.map((item) => {
        const isMatch = getData?.some(
          (localItem) => localItem?.awbNumber === item?.awbNumber
        );
        return {
          awbNumber: item?.awbNumber,
          value: item?.value,
          status: isMatch ? "SCANNED" : "COMPLETED",
        };
      });
      setManifestListArr(processedData);
      // setScannedManifestListArr(processedData);
    }
  }, [loader1, loader2]);
  // console.log(manifestListArr, "manifestListArr");

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleBarcode(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  const handleBarcode = (scanned_barcode) => {
    handleScanCallback(+scanned_barcode);
    // dispatch(patchManifestScan(scanned_barcode));
  };

  const onChangeHandler = (e) => {
    if (!hubId) {
      message.error("Please select hub");
      return;
    }
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(async () => {
      handleScanCallback(+e.target.value);
      // dispatch(patchManifestScan(+e.target.value));
    }, 900);
  };

  // console.log(scannedManifestListArr, "scannedManifestListArr")
  // console.log(manifestListArr, "manifestListArr");

  const totalIndividual = (objKey, packetStatus) => {
    return localScannedAwbs?.reduce((counter, obj) => {
      if (Object.keys(obj)?.includes(objKey) && obj?.status === packetStatus)
        counter += 1;
      return counter;
    }, 0);
  };

  const totalChildPacket = () => {
    return manifestListArr?.reduce((count, r) => {
      if (
        Object.keys(r)?.includes("childShipmentDetails") &&
        r?.childShipmentDetails !== null &&
        r?.childShipmentDetails?.length !== 0
      ) {
        count = count + +r?.childShipmentDetails?.length;
      }
      return +count;
    }, 0);
  };

  const totalPacket = (objKey) => {
    return manifestListArr?.reduce((counter, obj) => {
      if (Object.keys(obj)?.includes(objKey)) counter += 1;
      return counter;
    }, 0);
  };

  let finalized = totalIndividual("packetBarcode", "FINALISED");
  let completed = totalIndividual("awbNumber", "COMPLETED");
  let isDisabled = finalized == 0 && completed == 0 ? false : true;

  const handleRemoveScanCallback = (value) => {
    let isFound = false;

    // Update the manifestListArr by setting the status back to "NOT_SCANNED"
    const updatedManifestList = manifestListArr?.map((item) => {
      if (item?.awbNumber === +value && item?.status === "SCANNED") {
        isFound = true;
        return { ...item, status: "COMPLETED" };
      }
      return item;
    });

    setManifestListArr(updatedManifestList);

    // remove from local storage
    let pushUnScannedToLocal =
      JSON.parse(localStorage.getItem("scannedAwbs")) || [];
    let isExist = pushUnScannedToLocal?.some(
      (item) => item?.awbNumber === value
    );
    if (isExist) {
      pushUnScannedToLocal = pushUnScannedToLocal?.filter(
        (item) => item?.awbNumber !== value
      );
    }

    localStorage.setItem("scannedAwbs", JSON.stringify(pushUnScannedToLocal));
  };

  const handleScanCallback = (value) => {
    if (!hubId) {
      message.error("Please select hub");
      return;
    }
    let isFound = false;
    const temp = [...manifestListArr];

    const t2 = temp?.map((item) => {
      if (item?.awbNumber === +value) {
        isFound = true;
        return { ...item, status: "SCANNED" };
      }
      return item;
    });

    if (!isFound) {
      message.error(`AWB number ${value} not found in the manifest list.`);
    }
    setManifestListArr(t2);

    const findCurrentScannedAwb = manifestListArr?.find(
      (item) => item?.awbNumber === value
    );

    let pushScannedToLocal =
      JSON.parse(localStorage.getItem("scannedAwbs")) || [];
    let isExist = pushScannedToLocal?.some((item) => item?.awbNumber === value);
    if (!isExist) {
      pushScannedToLocal.push({ ...findCurrentScannedAwb, status: "SCANNED" });
    }

    localStorage.setItem("scannedAwbs", JSON.stringify(pushScannedToLocal));
  };

  const handleAllScanCallback = (value) => {
    if (!hubId) {
      message.error("Please select hub");
      return;
    }
    const temp = [...manifestListArr];

    const t2 = temp?.map((item, i) => {
      return { ...item, status: i < scannedLimit ? "SCANNED" : "COMPLETED" };
    });
    const scannedItems = t2?.filter((item) => item?.status === "SCANNED");
    const unScannedItems = t2?.filter((item) => item?.status !== "SCANNED");
    localStorage.setItem("scannedAwbs", JSON.stringify(scannedItems));
    setManifestListArr(unScannedItems);
    // setScannedManifestListArr(t2);
  };

  const checkScanEmpty = localScannedAwbs?.filter(
    (val) => val?.status?.toUpperCase() == "SCANNED"
  );
  const checkEligibleEmpty = manifestListArr?.filter(
    (val) => val?.status?.toUpperCase() == "COMPLETED"
  );

  useEffect(() => {
    getInitialCounts();
  }, []);

  const getInitialCounts = async () => {
    let url = ELIGIBLE_MANIFEST_LIST + "/manifest";
    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      let res = response?.response?.data;
      setPastPendingCount(res?.totalPendingCount || 0);
      setTodayCount(res?.todayPendingCount || 0);
    }
  };

  useEffect(() => {
    getDataByFilter(
      filters?.type,
      filters?.travel,
      filters?.serviceType,
      todayData
        ? moment().format("DD-MM-YYYY")
        : moment().subtract(7, "days").format("DD-MM-YYYY"),
      todayData
        ? moment().format("DD-MM-YYYY")
        : moment().subtract(1, "days").format("DD-MM-YYYY"),
      clientId
    );
  }, [clientId, todayData]);

  const getDataByFilter = async (
    docType,
    travel,
    serviceType,
    fromDate,
    toDate,
    client
  ) => {
    setLoading(true);
    let url = ELIGIBLE_MANIFEST_LIST + "/manifest";
    let queryParams = [];

    if (docType) {
      queryParams.push(`type=${docType}`);
    }

    if (travel) {
      queryParams.push(`travelBy=${travel}`);
    }
    if (serviceType) {
      queryParams.push(`serviceType=${serviceType}`);
    }
    if (fromDate) {
      queryParams.push(`fromDate=${fromDate}`);
    }
    if (toDate) {
      queryParams.push(`toDate=${toDate}`);
    }

    if (client) {
      queryParams.push(`client=${client}`);
    }

    if (queryParams?.length > 0) {
      url += `?${queryParams.join("&")}`;
    }
    let response = await API.Api(url).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      let res = response?.response?.data;
      const packet = res?.packetsdto || [];
      const shipment = res?.shipmentDto || [];
      const arr = [...packet, ...shipment];
      let getData = JSON.parse(localStorage.getItem("scannedAwbs"));
      let processedData = arr?.map((item) => {
        const isMatch = getData?.some(
          (localItem) => localItem?.awbNumber === item?.awbNumber
        );
        return { ...item, status: isMatch ? "SCANNED" : "COMPLETED" };
      });
      setManifestListArr(processedData);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  function handleFilter(type, travel, serviceType) {
    if (type == "clear") {
      // dispatch(getPacketListBySatus("manifest", "both"));
      setFilters({});
      getDataByFilter(
        null,
        null,
        null,
        todayData
          ? moment().format("DD-MM-YYYY")
          : moment().subtract(7, "days").format("DD-MM-YYYY"),
        todayData
          ? moment().format("DD-MM-YYYY")
          : moment().format("DD-MM-YYYY"),
        clientId
      );
    } else {
      setFilters({
        type,
        travel,
        serviceType,
      });
      getDataByFilter(
        type,
        travel,
        serviceType,
        todayData
          ? moment().format("DD-MM-YYYY")
          : moment().subtract(7, "days").format("DD-MM-YYYY"),
        todayData
          ? moment().format("DD-MM-YYYY")
          : moment().format("DD-MM-YYYY"),
        clientId
      );
    }
  }

  return (
    <Spin
      spinning={loader1 || loader3 || loader2 || loading}
      indicator={
        <img
          src={Smcs_Loader}
          style={{
            height: "90px",
            width: "90px",

            top: "42%",
            left: "47%",
          }}
        />
      }
    >
      <Row
        style={{
          position: "sticky",
          // top: "80px",
          // zIndex: "1",
          marginLeft: "20px",
          marginTop: "15px",
          // margin: "auto",
        }}
      >
        <Col span={13} className="align-center space-between">
          <Heading
            title={"Eligible Shipments"}
            navigateTo={"/viewBooking"}
            custom={true}
          />

          <Select
            placeholder="Select Hub"
            showSearch
            allowClear
            defaultActiveFirstOption
            popupClassName="view-booking-clients-dropDown"
            options={hubList}
            style={{ width: "40%", borderRadius: "5px", marginRight: "20px" }}
            className="mr-1"
            onChange={(value) => setHubId(value)}
            filterOption={(input, option) =>
              (option?.label ?? "")
                ?.toLowerCase()
                ?.includes(input?.toLowerCase())
            }
          ></Select>

          {/* <Radio.Group
            value={todayData}
            onChange={(e) => setTodayData(e.target.value)}
            className="ml-05"
          >
            <Radio value={true}>Today</Radio>
            <Radio value={false}>Pending</Radio>
          </Radio.Group> */}
        </Col>
        <Col span={11} className="d-flex">
          {" "}
          <Input
            onChange={(e) => onChangeHandler(e)}
            maxLength={15}
            style={{ width: "55%", borderRadius: "5px" }}
            placeholder="Enter AWB number to scan"
            disabled={
              localScannedAwbs?.filter((e) => e?.status === "SCANNED")
                ?.length >= scannedLimit
            }
            className="mr-1"
          />
          <Popconfirm
            // placement="Bottom"
            title={
              // manifestListArr?.length > scannedLimit ? (
              //   <span>
              //     Maximum scan limit is {scannedLimit} shipments.
              //     <br />
              //     Proceed with scanning {scannedLimit} shipments?
              //   </span>
              // ) : (

              <span>Are you sure you want to scan all shipments?</span>

              //)
            }
            cancelText="NO"
            okText="CONFIRM"
            icon={
              <QuestionCircleOutlined
                style={{
                  color: "red",
                }}
              />
            }
            disabled={
              localScannedAwbs?.filter((e) => e?.status === "SCANNED")
                ?.length >= scannedLimit
            }
            onConfirm={() => handleAllScanCallback()}
          >
            <Button
              disabled={
                localScannedAwbs?.filter((e) => e?.status === "SCANNED")
                  ?.length >= scannedLimit
              }
              className={
                localScannedAwbs?.filter((e) => e?.status === "SCANNED")
                  ?.length >= scannedLimit
                  ? "btn-style mr-1"
                  : "save-btn mr-1"
              }
            >
              SCAN ALL SHIPMENTS
            </Button>
          </Popconfirm>
        </Col>
      </Row>
      <Row>
        <Col lg={13}>
          <ManifestList
            name={""}
            checkEligibleEmpty={checkEligibleEmpty}
            packet={finalized}
            individual={completed}
            color={"yello"}
            packetAndShipmate={manifestListArr}
            packetStatus={"FINALISED"}
            shipmentStatus={"COMPLETED"}
            manifestFor={"both"}
            handleScanCallback={handleScanCallback}
            handleRemoveScanCallback={handleRemoveScanCallback}
            handleAllScanCallback={handleAllScanCallback}
            handleFilter={handleFilter}
            setClient={(id) => setClientId(id)}
            setTodayData={(e) => setTodayData(e)}
            pastPendingCount={pastPendingCount}
            todayPendingCount={todayCount}
          />
        </Col>

        <Col lg={11}>
          <ManifestList
            name={"Scanned shipments"}
            handleRemoveScanCallback={handleRemoveScanCallback}
            checkScanEmpty={localScannedAwbs?.length}
            color={"greens"}
            packetAndShipmate={localScannedAwbs || []}
            packetStatus={"SCANNED"}
            shipmentStatus={"SCANNED"}
            manifestFor={"both"}
            pastPendingCount={pastPendingCount}
            todayPendingCount={todayCount}
            totalScannedShipment={
              totalIndividual("awbNumber", "SCANNED") +
              totalIndividual("packetBarcode", "SCANNED")
            }
          >
            <NavigateButton
              loading={loading}
              setLoading={setLoading}
              manifestListArr={manifestListArr}
              packetNum={totalPacket("packetBarcode")}
              shipmentNum={totalPacket("awbNumber")}
              scannedPacket={totalIndividual("packetBarcode", "SCANNED")}
              scannedShipment={totalIndividual("awbNumber", "SCANNED")}
              isDisabled={isDisabled}
              totalChildPacket={totalChildPacket()}
              checkScanEmpty={checkScanEmpty}
              localScannedAwbs={localScannedAwbs}
              hubId={hubId}
              hubList={hubList}
            />
          </ManifestList>
        </Col>
      </Row>
    </Spin>
  );
}

const NavigateButton = ({
  manifestListArr,
  packetNum,
  shipmentNum,
  isDisabled,
  totalChildPacket,
  loading,
  checkScanEmpty,
  setLoading,
  localScannedAwbs,
  hubId,
  hubList,
}) => {
  const dispatch = useDispatch();
  const navigate = useCustomNavigate();

  const { CREATE_MANIFEST } = urls;

  // const getManifestId = JSON.parse(localStorage.getItem("manifestedId"));

  const createManifest__ = async (param) => {
    let manifestpayload = {
      type: "pickup",
      status: "INITIATED",
      // pickupDriverId: "null",
      travelBy: "BOTH",
    };

    setLoading(true);

    let response = await API.Api(CREATE_MANIFEST).postIdHeader(manifestpayload);
    if (response?.status) {
      setLoading(false);
      let res = response?.response?.data;

      localStorage.setItem("manifestedId", JSON.stringify(res?.manifestId));
      // readyToLoad(res?.manifestId, param);

      // setData(result);
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const createManifest = async (status) => {
    setLoading(true);
    let url = CREATE_MANIFEST_NEW;
    if (status) {
      url += `?status=${status}`;
    }

    const totalWeight = (objKey, packetStatus) => {
      return localScannedAwbs?.reduce((counter, obj) => {
        if (
          Object.keys(obj)?.includes(objKey) &&
          obj?.status === packetStatus
        ) {
          if (obj?.childShipmentDetails?.length !== 0) {
            obj?.childShipmentDetails?.forEach(
              (we) => (counter += we?.volumetricWeight)
            );
          }
          counter += obj?.volumetricWeight;
        }
        return counter;
      }, 0);
    };

    const totalVolWeight = (objKey, packetStatus) => {
      return localScannedAwbs?.reduce((counter, obj) => {
        if (
          Object.keys(obj)?.includes(objKey) &&
          obj?.status === packetStatus
        ) {
          if (obj?.childShipmentDetails?.length !== 0) {
            obj?.childShipmentDetails?.forEach((we) => (counter += we?.weight));
          }
          counter += obj?.weight;
        }
        return counter;
      }, 0);
    };

    let allManifestShipment = localScannedAwbs
      ?.filter((el) => el?.status == "SCANNED")
      ?.map((el) => ({
        awbNumber: el?.awbNumber || el?.packetBarcode,
        status: "ADDED",
        type: null,
        weight: el?.weight,
        childShipmentDetails: el?.childShipmentDetails,
      }));

    let patchData = {
      totalVolWeight: totalWeight("weight", "SCANNED")?.toFixed(2),
      shipmentNum: shipmentNum + totalChildPacket,
      packetNum: packetNum,
      status: "Added",
      travelBy: "both",
      manifestShipment: allManifestShipment,
      totalweight: totalVolWeight("weight", "SCANNED")?.toFixed(2),
      // hubId: hubId,
    };
    const currentenv = process.env.REACT_APP_ENV;

    if (hubId) {
      let hubData = hubList?.find((el) => el?.value == hubId);
      patchData.hubId = hubData?.value || hubId;

      patchData.hubName = hubData?.hubName;
      patchData.hubAddress = hubData?.hubAddress;
    }

    let response = await API.Api(url).postIdTokenHeader(patchData);
    let getId = response?.response?.data?.manifestId;
    if (response?.status) {
      setLoading(false);
      if (status) {
        message.success("Manifest locked successfully");
        navigate("/viewBooking");
        localStorage.setItem("scannedAwbs", JSON.stringify([]));
      } else {
        navigate(`/truck/${getId}`);
        localStorage.setItem("scannedAwbs", JSON.stringify([]));
      }
      localStorage.setItem("manifestedId", JSON.stringify(getId));
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  return (
    <>
      <div className="scan-container-header-line"></div>

      <div
        style={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}
        className
      >
        <Button
          className="navigate-button "
          onClick={() => createManifest("LOCKED")}
          disabled={checkScanEmpty?.length == 0}
        >
          GENERATE MANIFEST WITHOUT VEHICLE
        </Button>
        <Button
          className="navigate-button ml-1"
          onClick={() => createManifest()}
          disabled={checkScanEmpty?.length == 0}
        >
          ready to load
        </Button>
      </div>
    </>
  );
};

export default ScanedandManifestList;
